import {getUser} from '../sanity/sanity';

async function GetUserData(){
  const userData = await getUser();
  return userData[0];
}



export default GetUserData;